<template>
  <div>
    <v-select
      :name="name"
      :label="label"
      :items="optionsArray"
      item-text="label"
      item-value="value"
      v-model="localValue"
      @change="inputCallback"
      dense
      outlined
      :readonly="readonly"
      :disabled="readonly"
      :class="readonly ? 'select-readonly' : ''"
      placeholder="Selecione"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
export default {
  name: "ComboboxInputComponent",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
    },
    options: {
      type: [Object, Array],
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false
    },

    grouped: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  
  data() {
    return {
      localValue: this.value
    }
  },

  computed: {
    optionsArray() {
      if (!this.options) return []

      if (!Array.isArray(this.options)) {
        return Object.keys(this.options).map(key => ({
          label: this.options[key],
          value: key
        }))
      }

      if (!this.grouped) {
        return this.options
      }

      // Monta array com headers de grupo para o v-select do Vuetify
      const result = []
      const gruposVistos = {}
      this.options.forEach(op => {
        const grupo = op.grupo || ''
        if (grupo && !gruposVistos[grupo]) {
          gruposVistos[grupo] = true
          result.push({ header: grupo })
        }
        result.push(op)
      })
      return result
    }
  },

  watch: {
    value(newVal) {
      this.localValue = newVal
    }
  },
  
  methods: {
    inputCallback(value){
      this.$emit('input', value)
      this.$emit('update', {
        name: this.name,
        model: value
      })
      this.$emit('validation', { hasErrors: false })
    }
  }
};
</script>

<style scoped>
.select-readonly {
  pointer-events: none;
  opacity: 0.6;
}
</style>